export default "__VITE_ASSET__Bpq67wUL__"